import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setThePayslipDataactionforemp } from "../../../../../../Redux/Slice";
// import Table from "../../../Appcomponent/Table";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import HeadingComp from "../../../UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
// import data from "../../../../Json/English";
// import hindiDatas from "../../../../Json/Hindi";
import "../../../../../../StyleSheet/MainComponent/UDSEMployee/PaySlip.scss";
import TextField from "@mui/material/TextField";
import axios from "axios";
import ReactTable from "../../../../../AppComponent/Table";
import _, { values } from "lodash";
import BackImage from "../../../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import { useNavigate } from "react-router-dom";


const PaySlipEmp = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [tableFeeder, setTableFeeder] = useState([]);
  const [fileName, setFileName] = useState([]);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state)
  const joiningYear = state.PayLipEMployeeeData.JoiningDate;

  const today = dayjs();
  const yesterday = dayjs().subtract(1, "day");
  // const currentYear = dayjs().year();

  // const validYear = joiningYear && Number(joiningYear) <= currentYear
  //   ? joiningYear
  //   : "2024"; 

  //   console.log(joiningYear ,"joiningYear");

  // const startYearDate = dayjs(`${validYear}-01-01T00:00:00.000`);

  // const [startYear, setStartYear] = useState(startYearDate.toISOString());
  const startYearFeeder = dayjs(`${joiningYear}-01-01T00:00:00.000`); // Use the joining year as the date limit
  const currentYear = dayjs().year();
  const validYear = joiningYear && Number(joiningYear) <= currentYear ? joiningYear : "2024";

  console.log(joiningYear, "joiningYear");

  const startYearDate = dayjs(`${validYear}-01-01T00:00:00.000`);
  const [startYear, setStartYear] = useState(startYearDate.toISOString());

  // Define the minimum and maximum date based on joining year and current year
  // const startYearFeeder = dayjs(`${validYear}-01-01T00:00:00.000`); // Earliest allowed year (joining year)
  const maxYearDate = dayjs(`${currentYear}-12-31T23:59:59.999`);   // Latest allowed year (current year)


  const [search, setsearch] = useState("")

  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const currentYearlist = new Date()
  const [PayslipYear, setPayslipYear] = useState(state.PayLipEMployeeeData.JoiningDate != "" ? Number(state.PayLipEMployeeeData.JoiningDate) :

    currentYearlist.getFullYear());

  useEffect(() => {
    const payload = {
      year: PayslipYear,
      search: search,
      page: dtpageindex,
      page_size: 10,

    }
    dispatch(setThePayslipDataactionforemp(payload));
  }, [PayslipYear, search, dtpageindex]);


  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleYearChange = (year) => {
    setPayslipYear(year);

  };
  // useEffect(() => {
  //   if (joiningDate !== undefined) {
  //     setStartYear(joiningDate + "-01-01T00:00:00.000");
  //   }
  // }, [joiningDate]);

  const getMonthFromDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: "long" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };
  const handleDownload = (url, month) => {
    let year = month.slice(0, 4);
    let fileNames =
      "asdasd" + "_" + year + "-" + getMonthFromDate(month) + "_payslip.png";

    axios({
      url: url,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileNames);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => console.error("Error downloading file:", error));
  };
  const handleView = (payload) => {
    window.open(payload, "_blank");
  };
  const columns = [
    {
      Header: "MONTH",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.month != undefined ? (
              <span>
                {getMonthFromDate(row.row.original.month)}
              </span>
            ) : (
              <span>{"Not mention"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "ACTIONS",
      accessor: "",
      Cell: (row) => {
        return (
          <div className="ActionDiv">
            {row.row.original.slip_url != null && row.row.original.slip_url != undefined &&
              row.row.original.slip_url != "" &&
              row.row.original.slip_url.media_url !=null &&
              row.row.original.slip_url.media_url != undefined &&
              row.row.original.slip_url.media_url !="" ?
              <> 
              <button
                className="ActionButton"
                onClick={() => {
                  handleDownload(
                    row.row.original.slip_url.media_url,
                    row.row.original.month
                  );
                }}
              >
                Download
              </button>
                <button
                  className="ActionButton"
                  onClick={() => handleView(row.row.original.slip_url.media_url)}
                >
                  View
                </button>
                </>
                :"Not uploaded"
            }
             
          </div>
        );
      },
    },
  ];

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  console.log(state.PayLipEMployeeeData.JoiningDate, "sdasd PaylipaE  mployeeData", PayslipYear);



  return (
    <div className={stateDisplay ? "outterContent" : "inner-Content"}>
      <div className="payslipWrapper">
        {/* <HeadingComp
          english={EnglishData.payslip.heading}
          hindi={HindiData.leave.heading}
        /> */}
        <div className="row">
          <div className="col-12 leaveHeading text-left">
            <h3>PAYSLIP</h3>
          </div>
        </div>


        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "7px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
            marginLeft: "-16px",
            marginRight: "0px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/employment");
              }}
            >
              <img className="PreviousPages" src={BackImage} />
              <span></span>

            </button>
          </div>
          <div className="calenderDiv">
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Year"
                views={["year"]}
                defaultValue={today}
                maxDate={startYearFeeder}
                minDate={startYearFeeder}
                onChange={(date) => {
                  const selectedYear = date.year();
                  handleYearChange(selectedYear);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Year"
                views={["year"]}
                defaultValue={startYearFeeder} // Starts with the joining year
                minDate={startYearFeeder}      // Earliest selectable date (joining year)
                maxDate={maxYearDate}          // Latest selectable date (current year)
                onChange={(date) => {
                  const selectedYear = date.year();
                  handleYearChange(selectedYear);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>


          </div>
        </div>




        <ReactTable
          data={state.PayLipEMployeeeData.PaylipaEmployeeData}
          datacount={10}
          columns={columns}
          // dispatchApiCall={dispatchApiCall}
          pagesize={pagesize}
          dtpagesize={20}
          dtpageindex={dtpageindex}
          pageindex={pageindex}
          Search={true}
          onPrevious={handlePrevious}
          onNextpage={handleNext}
          GotoEnteredPage={GotoEnteredPage}
          onChange={tochange}
          Filter={false}


        />

      </div>
    </div>
  );
};

export default PaySlipEmp;
